import EmbedForm from "@pathwright/ui/src/components/embed/EmbedForm"
import EmbedDisplay from "./EmbedDisplay"
import { EmbedEditWrap } from "./ui"

const EmbedEdit = ({ data, layout, blockStyles, onChange }) => {
  const { embed_code, url } = data

  return (
    <EmbedEditWrap blockStyles={blockStyles}>
      <EmbedForm
        url={url}
        embedCode={embed_code}
        onChange={({ url, embedCode }) =>
          onChange({
            url,
            embed_code: embedCode
          })
        }
        renderEmbed={({ embedCode }) => (
          // using blocks custom EmbedDisplay which handles template context
          // and katex
          <EmbedDisplay layout={layout} embedCode={embedCode} />
        )}
      />
    </EmbedEditWrap>
  )
}

EmbedEdit.displayName = "EmbedEdit"

export default EmbedEdit
